"use client";
import { jsx as r } from "react/jsx-runtime";
import { createContext as n, useContext as i } from "react";
const e = n(void 0), x = ({ children: t, widget: o }) => /* @__PURE__ */ r(e.Provider, { value: o, children: t }), d = () => i(e);
export {
  x as WidgetProvider,
  d as useWidget
};
